<template>
  <div class="check-work-body d-flex">
    <div class="d-flex-left">
      <FlowProfessionalTypeTree height="85vh" @nodeClick="nodeClick" />
    </div>
    <div class="d-flex-right">
      <div class="search-wrap">
<!--        <el-button size="mini" type="primary" @click="editArticle()" style="margin-right: 5px;" icon="el-icon-plus">添加</el-button>-->
        <el-input size="mini" placeholder="请输入搜关键字" v-model="keyword" clearable style="width: 200px"></el-input>
        <el-input size="mini" placeholder="流程ID" v-model="task_id" clearable style="width: 100px; margin-left:10px"></el-input>
        <el-select size="mini" v-model="work_status" clearable  placeholder="状态" style="width: 100px; margin-left:10px">
          <el-option label="正常" value="1">正常</el-option>
          <el-option label="失败" value="2">失败</el-option>
        </el-select>
        <el-button size="mini" type="primary" @click="search" style="margin-left:10px">搜索</el-button>
      </div>

      <div class="table-wrap">
        <el-table v-if="pageData" v-loading="loading" :data="pageData.list">
          <el-table-column prop="id" label="id" align="center" width="90"></el-table-column>
          <el-table-column prop="task_name" label="流程名称" align="center" width="180"></el-table-column>
          <el-table-column prop="work_name" label="业务名称" align="center" width="100"></el-table-column>
          <el-table-column prop="type_name" label="业务类型" align="center" width="100"></el-table-column>
          <el-table-column prop="method" label="处理方式" align="center" width="90"></el-table-column>
          <el-table-column prop="url" label="地址" align="center" width="240">
            <template slot-scope="scope">
              <div style="width: 230px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{scope.row.url}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" align="center" width="100">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status===0" type="info">无</el-tag>
              <el-tag v-if="scope.row.status===1">在进行</el-tag>
              <el-tag v-if="scope.row.status===2" type="success">完成</el-tag>
              <el-tag v-if="scope.row.status===3" type="warning">业务异常</el-tag>
              <el-tag v-if="scope.row.status===4" type="danger">流程异常</el-tag>
            </template>
          </el-table-column>

          <el-table-column prop="create_time" label="启动时间" align="center" width="150"></el-table-column>
          <el-table-column prop="update_time" label="修改时间" align="center" width="150"></el-table-column>
          <el-table-column label="操作" align="center" width="100">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" icon="el-icon-info" @click="editArticle(scope.row)">详情</el-button>
<!--              <el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteCmsChannel(scope.row)">删除</el-button>-->
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagination-wrap">
        <el-pagination background layout="prev, pager, next" :total="pageData.total*1" :page-size="pageData.pageSize*1" :current-page="pageData.page*1" @current-change="pageChange"></el-pagination>
      </div>
    </div>



    <!-- 修改窗口 -->
    <el-dialog title="编辑" :visible.sync="dialogVisible" :close-on-click-modal="false" width="600px">

      <div style="max-height: 500px;overflow-y: auto;">
        <el-form :model="form" ref="form" label-width="100px" size="mini" style="margin-right: 50px;">
          <el-form-item label="流程名称" prop="title">{{form.task_name}}</el-form-item>
          <el-form-item label="业务名称" prop="title">{{form.work_name}}</el-form-item>
          <el-form-item label="业务类型" prop="title">{{form.type_name}}</el-form-item>
          <el-form-item label="处理方式" prop="title">{{form.method}}</el-form-item>
          <el-form-item label="请求地址" prop="title">{{form.url}}</el-form-item>
          <el-form-item label="请求参数" prop="title">{{form.form_data}}</el-form-item>
          <el-form-item label="状态" prop="title">
            <el-tag v-if="form.status===0" type="info">无</el-tag>
            <el-tag v-if="form.status===1">在进行</el-tag>
            <el-tag v-if="form.status===2" type="success">完成</el-tag>
            <el-tag v-if="form.status===3" type="warning">业务异常</el-tag>
            <el-tag v-if="form.status===4" type="danger">流程异常</el-tag>
          </el-form-item>
          <el-form-item label="处理结果" prop="title">{{form.context}}</el-form-item>
        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button :loading="button_loading" type="primary" @click="submitForm()" >重新触发</el-button>
        <el-button @click="dialogVisible = false">关 闭</el-button>
<!--        <el-button type="primary" @click="submitForm('form')" >确 定</el-button>-->
      </div>
    </el-dialog>
  </div>
</template>

<script>
// {$房产}
import Http from "./common/Http";
import UploadFilesSysc from "./components/UploadFilesSysc";
import UploadFileSysc from "./components/UploadFileSysc";
import FlowProfessionalTypeTree from "./components/FlowProfessionalTypeTree";

export default {
  name:"FlowProfessionalWorkLog",
  components: {FlowProfessionalTypeTree, UploadFileSysc, UploadFilesSysc},
  data () {
    return {
      host_url:"",
      keyword: '',
      task_id: '',
      work_status: '',
      type_id: '',
      loading: false,
      contract_area_id:'',
      pageData:{
        list:[],
        total:0,
        pageSize:20,
        page:1
      },
      dialogVisible:false,
      form:{
        name:"",
        type_id:"",
        url:"",
        method:"post",
        form_data:"",
        status:"",
      },
      uploadUrl:"",
      button_loading:false,
    }
  },
  created() {
    this.host_url=Http.getBaseURL();
    this.uploadUrl=this.host_url+"flow/FlowType/uploadFile";
  },
  activated() {
    this.getList()
  },
  watch: {
    dialogVisible(val) {
      if(val == false) {
        // this.fileList = []
      }
    },

  },
  methods: {
    getFormData(data) {
      return Object.assign({
        id:'',
        name:"",
        type_id:"",
        url:"",
        method:"post",
        form_data:"",
        status:"",
      }, data)
    },
    search() {
      this.pageData.page = 1
      this.getList()
    },
    getList() {
      const that = this;
      that.loading=true;
      let where={};
      this.keyword&&(where.name=this.keyword);
      this.task_id&&(where.task_id=this.task_id);
      this.work_status&&(where.work_status=this.work_status);
      this.type_id&&(where.type_id=this.type_id);
      Http.get("flow/FlowProfessionalWorkLog/getList",{
        where:JSON.stringify(where),
        page: this.pageData.page,
        page_size: this.pageData.pageSize
      },res=>{
        if(res.code) {
          that.pageData=res.data
        }
        that.loading=false;
      })
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    editArticle(item) {
      if(!item) {
        this.form = this.getFormData({})
      } else {
        this.form = item
      }
      this.dialogVisible = true
    },

    submitForm() {
      const that = this;
      let form_data=JSON.parse(that.form.form_data)
      that.button_loading=true;
      Http.post(that.form.url,form_data,ret=>{
        that.button_loading=false;
        if(ret.code===200){
          that.formLoading = true
          let data = Object.assign({}, this.form)
          data.status=2;
          Http.post("flow/FlowProfessionalWorkLog/save",data,res => {
            that.$message({type: res.code === 1 ? 'success': 'error', message: res.msg})
            if(res.code) {
              that.dialogVisible = false
              that.getList()
            }
            that.formLoading = false
          })
        }else {
          that.$message.error(ret.message||"系统异常")
        }
      })
    },

    setFrom(data){
      const that = this;
      Http.post("flow/FlowProfessionalWorkLog/save",data,res => {
        that.$message({type: res.code === 1 ? 'success': 'error', message: res.msg})
        if(res.code) {
          that.getList()
        }
      })
    },
    deleteCmsChannel(item){
      const that = this;
      Http.post("flow/FlowProfessionalWorkLog/delete", {id:item.id},res => {
        that.$message({type: res.code === 1 ? 'success': 'error', message: res.msg})
        if(res.code) {
          that.getList()
        }
      })
    },
    nodeClick(e){
      this.type_id=e.id;
      this.type_name=e.name;
      this.pageData.page = 1
      this.getList();
    },
  }
}
</script>
<style lang="scss" scoped>

@import './common.scss';

.check-work-body {
  padding: 15px;
  width: 98%;
}

.search-wrap {
  padding-bottom: 15px;
  border-bottom: 1px solid #EBEEF5;
  display: flex;
  flex-direction: row;
  //justify-content: space-between;
}

.table-wrap {
  margin-top: 5px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  flex-direction: row;
  align-content: flex-start;
  justify-content: flex-start;

  .table-wrap-item{
    margin: 10px 0;
    width: 250px;
    margin-left: 20px;
    cursor: pointer;
    height: 50px;

    .el-card-item{
      padding: 15px;
    }
  }
}

.pagination-wrap {
  display: flex;
  justify-content: center;
  margin-top: 15px;
}
.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  //flex: 1;
}

.form-input {
  width: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/FlowProfessionalWorkLog.vue